import classNames from "classnames";
import { CollegeCampuses } from "components/GeneralData/CollegeCampuses";
import { ZipCodes } from "components/GeneralData/ZipCodes";
import { Fragment, useState } from "react";

// import DatePicker from "react-datepicker";

export const GeneralData = () => {
  const [tab, setTab] = useState("College Campuses");

  return (
    <Fragment>
      <div className="flex flex-col mb-4">
        <h1 className="font-medium text-gray-800 tracking-wide text-xl">
          {tab}
        </h1>
        <p className="page-subtitle">View all {tab}</p>
      </div>

      {/* Tables */}
      {tab === "College Campuses" ? <CollegeCampuses /> : <ZipCodes />}

      {/* Tabs */}
      <div className="tabs mt-4">
        <div className="flex flex-wrap gap-1">
          <button
            type="button"
            onClick={() => setTab("College Campuses")}
            className={classNames(tabStyles.default, {
              [tabStyles.active]: tab === "College Campuses",
            })}
          >
            College Campuses
          </button>
          <button
            type="button"
            onClick={() => setTab("Zip Codes")}
            className={classNames(tabStyles.default, {
              [tabStyles.active]: tab === "Zip Codes",
            })}
          >
            Zip Codes
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export const tabStyles = {
  default:
    "tab",
  active: "tab-active",
  select:
    "text-xs py-1.5 pl-2.5 pr-7",
};
